<template>
  <div class="list-view">
    <div
      class="header"
      v-if="data.length"
    >
      <div
        class="column"
        :class="{ 'column-sorted': sort && sort.column === column.field }"
        v-for="column in columns"
        :key="column.field"
        :style="{ width: column.width }"
        @click="onSort(column)"
      >
        <div class="label">
          {{ column.label }}
        </div>
        <div class="sort">
          <i class="sort-asc" :class="{ active: isSorted(column, 'ASC')}" />
          <i class="sort-desc" :class="{ active: isSorted(column, 'DESC')}" />
        </div>
      </div>
    </div>
    <div class="body">
      <div class="row" v-for="row in data" :key="row.id" @click="onView(row)">
        <div
          class="column"
          :class="{ 'column-sorted': sort && sort.column === column.field }"
          v-for="column in columns"
          :key="`${row.id}-${column.field}`"
          :style="{ width: column.width }"
        >
          {{ row[column.field] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "ListView",
    props: {
      data: {
        type: Array,
        required: true
      },
    },
    computed: {
      ...mapState("recipes", ["columns", "sort"]),
    },
    methods: {
      onSort(column) {
        this.$emit("sort", column);
      },
      onView(row) {
        this.$emit("view", row);
      },
      isSorted(column, direction) {
        if (!this.sort) {
          return;
        }

        return (
          this.sort.column === column.field && this.sort.direction === direction
        );
      }
    }
  };
</script>

<style scoped lang="scss">
  .list-view {
    display: flex;
    flex-direction: column;

    .header {
      display: flex;

      .column {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: $font-semibold;
        cursor: pointer;
        user-select: none;
        padding: 16px $gutter;

        .sort {
          position: relative;
          height: 20px;

          .sort-asc,
          .sort-desc {
            position: absolute;
            top: 0;
            left: 8px;
            display: inline-block;
            width: 0;
            height: 0;
            border: solid 5px transparent;
            margin: 2px;
            background: transparent;
          }

          .sort-asc {
            border-bottom: solid 7px $color-border;
            border-top-width: 0;

            &.active {
              border-bottom-color: $color-secondary;
            }
          }

          .sort-desc {
            border-top: solid 7px $color-border;
            border-bottom-width: 0;
            top: 12px;

            &.active {
              border-top-color: $color-secondary;
            }
          }
        }

        &.column-sorted {
          background: #eee;
        }
      }
    }

    .body {
      display: flex;
      flex-direction: column;

      .row {
        display: flex;
        background: $color-white;
        border-bottom: 1px solid transparent;
        border-top: 1px solid #eee;
        cursor: pointer;

        &:last-of-type {
          border-bottom: none;
        }

        &:hover {
          background: rgba($color-primary, 0.02);
          border-color: rgba($color-primary, 0.2);
          cursor: pointer;

          .column,
          .column.column-sorted {
            background: rgba($color-primary, 0.02);
            cursor: pointer;
          }

          + .row {
            border-top-color: transparent;
          }
        }

        .column {
          padding: 12px $gutter;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;

          &.column-sorted {
            background: #fafafa;
          }
        }
      }
    }

    @media (max-width: $media-small) {
      // only show first column on mobile
      .header .column,
      .body .row .column {
        display: none;

        &:first-child {
          display: flex;
          width: 100% !important;
        }
      }

      .body .row .column:first-child {
        display: block;
      }
    }
  }
</style>
